var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPenGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2659 3.98325L10.0826 1.79992L10.7492 1.13325C10.9603 0.922143 11.2187 0.819365 11.5242 0.824921C11.8298 0.830476 12.0937 0.93881 12.3159 1.14992L12.9492 1.76659C13.1714 1.98881 13.2742 2.24992 13.2576 2.54992C13.2409 2.84992 13.127 3.10548 12.9159 3.31659L12.2659 3.98325ZM1.61589 13.1166C1.427 13.1166 1.26866 13.0527 1.14089 12.9249C1.01311 12.7971 0.949219 12.6388 0.949219 12.4499V11.1999C0.949219 11.1221 0.965885 11.0444 0.999219 10.9666C1.03255 10.8888 1.08255 10.8166 1.14922 10.7499L9.38255 2.49992L11.5659 4.66659L3.33255 12.9166C3.25477 12.9833 3.177 13.0333 3.09922 13.0666C3.02144 13.0999 2.93811 13.1166 2.84922 13.1166H1.61589Z",
    fill: "#222529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPenGray);
export default __webpack_public_path__ + "static/media/IconPenGray.40275fc077e1dbc17dfcf321e0192408.svg";
export { ForwardRef as ReactComponent };